module.exports = __webpack_public_path__ + "img/wx_follow_bg3.f6559b4a.png";